import styled from 'styled-components';

export const SelectionList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 0;
  margin-bottom: 10px;
`;

export const SelectionListItem = styled.li`
  display: grid;
  grid-template-columns: minmax(auto, max-content) auto;
  gap: 20px;
  grid-row-gap: 20px;

  > *:nth-child(2) {
    justify-self: end;
  }
`;

export const SelectionPrice = styled.div`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;
